 /*
创建者 魏强(2018.1.25)
还没逛够
*/
<template>
  <div class="home-module">
    <h3 class="module-title dash"><span>还没逛够</span></h3>
    <div class="module-goods">
      <ul class="clearfix" id="hmggDiv">
        <li v-for="item in list" :key="item.goodsId">
          <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" target="_blank">
            <div class="img">
              <img :src="item.designImage" :atl="item.name" />
            </div>
            <div class="tit">{{item.name}}</div>
            <div class="pri">&yen;&nbsp;{{item.price}}</div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { continueShopping } from "api/home";
export default {
  props: ["data"],
  data() {
    return {
      list: this.data,
      pageNo: 2,
      pageSize: 15,
      type: 0,
      hasMore: true,
      loading: false,
      hasBoundScroll: false
    }
  },
  created() {
    this.bindScroll();
  },
  destroyed() {
    $(window).unbind("scroll");
  },
  activated() {
    this.bindScroll();
  },
  deactivated() {
    $(window).unbind("scroll");
    this.hasBoundScroll = false;
  },
  methods: {
    fetchData() {
      if (this.hasMore && !this.loading) {
        this.loading = true;
        continueShopping(this.pageNo, this.pageSize, this.type).then(json => {
          this.loading = false;
          if (json.resCode == 1) {
            let data = json.data;
            this.hasMore = data.hasMore;
            if (this.hasMore) {
              this.pageNo = this.pageNo + 1;
            }
            let list = data.list || [];
            let temp = this.list;
            this.list = temp.concat(list);
          }
        });
      }
    },
    bindScroll() {
      //防止重复绑定
      if (!this.hasBoundScroll) {
        let _this = this;
        this.hasBoundScroll = true;
        $(window).scroll(function (e) {
          var scrollTop = $(this).scrollTop();
          var scrollHeight = $(document).height();
          var windowHeight = $(window).height();
          if (scrollTop + windowHeight + 430 >= scrollHeight && _this.hasMore && !_this.loading) {
            _this.fetchData();
          }
        });
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// index.vue?1b26b947